import {
  ApprovalStatus,
  ApprovalSubject,
  EvaluationResult,
  EvaluationResults,
} from "../../../domain/ApprovalSubject";
import { RefQualificationLevelModel } from "../../../domain/RefQualificationLevelModel";
import { RefQualificationTypeModel } from "../../../domain/RefQualificationTypeMode";
import { SubjectModel } from "../../../domain/SubjectModel";

export interface IEvaluationApprovalCardProps {
  subject: SubjectModel;
  matchingLevel: RefQualificationLevelModel;
  matchingQualType: RefQualificationTypeModel | undefined;
  approvalSubjects: ApprovalSubject[];
  setApprovalSubjects: React.Dispatch<React.SetStateAction<ApprovalSubject[]>>;
  dataTest?: string | null | undefined;
  readOnly: boolean;
}

export const evaluationKeys: string[] = [
  "makingAssessment",
  "designingDevelopingAssessments",
  "evaluatingAssessments",
  "standardSetting",
  "teacherTrainingAssessment",
  "trainingAssessment",
  "teachingLecturingAssessment",
  "educationManagementAssessment",
  "industryAssessment",
];

export const handleSetApprovalSubject = (
  subjectId: string,
  levelId: number,
  key: keyof EvaluationResults,
  status: ApprovalStatus,
  approvalSubjects: ApprovalSubject[],
  setApprovalSubjects: React.Dispatch<React.SetStateAction<ApprovalSubject[]>>
) => {
  const subjectHasKey = evaluationKeys.includes(key);

  const subject = approvalSubjects.find((s) => s.subjectId === subjectId);

  let subjectIndex: number = 0;
  let newSubject: ApprovalSubject;

  let approvalLevel = {
    levelId: levelId,
    evaluationResults: {
      makingAssessment: {} as EvaluationResult,
      standardSetting: {} as EvaluationResult,
      designingDevelopingAssessments: {} as EvaluationResult,
      evaluatingAssessments: {} as EvaluationResult,
      teachingLecturingAssessment: {} as EvaluationResult,
      trainingAssessment: {} as EvaluationResult,
      educationManagementAssessment: {} as EvaluationResult,
      teacherTrainingAssessment: {} as EvaluationResult,
      industryAssessment: {} as EvaluationResult,
    } as EvaluationResults,
  };

  if (subject === undefined) {
    newSubject = {
      subjectId,
      levels: [approvalLevel],
    };

    const levels = newSubject.levels;
    if (subjectHasKey) {
      levels[0].evaluationResults![key]!.approvalStatus = status;
    }
  } else {
    subjectIndex = approvalSubjects.findIndex((s) => s.subjectId === subjectId);
    newSubject = subject;

    if (subjectHasKey) {
      if (newSubject.levels.length === 0) {
        newSubject["levels"] = [approvalLevel];
        newSubject.levels[0].evaluationResults![key]!.approvalStatus = status;
      } else {
        const existingLevel = newSubject.levels.find(
          (l) => l.levelId === levelId
        );
        if (existingLevel === undefined) {
          newSubject.levels.push(approvalLevel);
          newSubject.levels[newSubject.levels.length - 1].evaluationResults![
            key
          ]!.approvalStatus = status;
        } else {
          const existingLevelIndex = newSubject.levels.findIndex(
            (s) => s.levelId === levelId
          );

          // This may become obsolete
          if (
            newSubject.levels[existingLevelIndex].evaluationResults![key] ===
            null
          ) {
            newSubject.levels[existingLevelIndex].evaluationResults![
              key
            ] = {} as EvaluationResult;
          }
          newSubject.levels[existingLevelIndex].evaluationResults![
            key
          ]!.approvalStatus = status;
        }
      }
    }
  }

  setApprovalSubjects((prev) => {
    if (subject !== undefined) {
      prev[subjectIndex] = newSubject;
      return [...prev];
    }

    return [...prev, newSubject];
  });
};
